import { isBillingComplete } from "./profileCompletion";

// Müşteri teklifi kabul ettikten sonra fatura + ödeme kurulumu tamam mı?
// Aynı kural hem teklif sonrası açılan modalda hem anasayfadaki uyarı bandında kullanılır.
//
// userInfo: GetUserInfos sonucu (null ise henüz bilinmiyor → uyarı gösterilmez)
// cards: get-payment-ledger sonucundaki "cards" dizisi (null ise henüz bilinmiyor)
// { known, billingMissing, paymentMissing, ready }
export function getBillingReadiness({ userInfo = null, cards = null } = {}) {
  const known = Boolean(userInfo) && Array.isArray(cards);
  if (!known) {
    return { known: false, billingMissing: false, paymentMissing: false, ready: true };
  }

  const billingMissing = !isBillingComplete(userInfo, userInfo?.nationality || "tc");
  const paymentMissing = cards.length === 0;

  return {
    known: true,
    billingMissing,
    paymentMissing,
    ready: !billingMissing && !paymentMissing,
  };
}
